<div
    class="d-flex justify-content-between col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 col-xxl-10 mx-auto c11n-space-stack-1x c11n-space--force"
>
    <div class="flow-caption space-between c11n-text-sm no-contact-us">
        {{ flowCaption }}
    </div>

    <div class="d-flex spaced-buttons no-contact-us">
        <c11n-button
            buttonType="button"
            size="small"
            variant="ghost"
            [iconName]="'remove'"
            [labelText]="addUserFlowGrantorContent.navQuit"
            [iconPosition]="'trailing'"
            (clickEvent)="quitButtonModalDialog.openModalDialog()"
            data-cy="quit-button"
        >
        </c11n-button>
    </div>
</div>

<c11n-modal-dialog-entrypoint></c11n-modal-dialog-entrypoint>
<c11n-modal-dialog
    [variant]="'warning'"
    [primaryButtonLabel]="addUserFlowGrantorContent.wrnQuitUnsaved.navYes"
    [secondaryButtonLabel]="addUserFlowGrantorContent.wrnQuitUnsaved.navNo"
    [headingText]="addUserFlowGrantorContent.wrnQuitUnsaved.heading"
    [hideBody]="true"
    (primaryClick)="quitClickEvent.emit()"
    (secondaryClick)="quitButtonModalDialog.closeDialogModal()"
    [maxWidth]="660"
    [useContentWidth]="false"
    data-cy="error-modal"
    #quitButtonModalDialog
>
</c11n-modal-dialog>
